<div class="container-forgotpass">
    <div class="container-title-forgot">
        <p nz-typography>
            {{ 'login.forgotPassword' | translate }}
        </p>
    </div>
    <div class="container-form">
        <form [formGroup]="forgotPasswordForm" (ngSubmit)="submit()">
            <nz-form-item>
                <nz-form-control nzErrorTip="{{ 'login.invalidEmail' | translate }}">
                    <nz-form-label nzFor="forgotEmail">
                        {{ 'login.username' | translate }}
                    </nz-form-label>
                    <nz-input-group>
                        <input id="forgotEmail" type="text" nz-input nzSize="large" formControlName="email"
                            placeholder="{{ 'login.writeEmail' | translate }}" />
                    </nz-input-group>
                </nz-form-control>
            </nz-form-item>
            <div class="modal-footer">
                <ds-button [text]="'buttons.back' | translate" [width]="'small'" [styleType]="'empty-main'" class="cancel text-uppercase" (click)="goBack()"></ds-button>
                <ds-button [text]="'buttons.confirm' | translate" [width]="'small'" [isDisabled]="forgotPasswordForm.invalid" class="text-uppercase second-btn"></ds-button>
            </div>
        </form>
    </div>
</div>


<nz-modal [(nzVisible)]="isSuccessModalVisible" nzCentered [nzTitle]="modalTitle" [nzContent]="modalContent"
    [nzFooter]="modalFooter">
    <ng-template #modalTitle>
        <h1>{{ 'login.modal.title' | translate }}</h1>
    </ng-template>

    <ng-template #modalContent>
        <p>{{ 'login.modal.content' | translate }}</p>
    </ng-template>

    <ng-template #modalFooter>
        <ds-button [text]="'login.modal.close' | translate" [width]="'small'" class="text-uppercase" (click)="handleSuccessOk()"></ds-button>
    </ng-template>
</nz-modal>

<nz-modal [(nzVisible)]="isErrorModalVisible" nzCentered [nzTitle]="modalTitle" [nzContent]="modalContent"
    [nzFooter]="modalFooter">
    <ng-template #modalTitle>
        <h1>{{ 'login.modal.titleLogin' | translate }}</h1>
    </ng-template>

    <ng-template #modalContent>
        <p>{{ 'login.modal.contentLogin' | translate }}</p>
    </ng-template>

    <ng-template #modalFooter>
        <ds-button [text]="'login.modal.close' | translate" [width]="'small'" class="text-uppercase" (click)="handleErrorOk()"></ds-button>
    </ng-template>
</nz-modal>